(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   drupal behavior
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {

		// initialize main navigation:
		new duo.Navigation({
			navSelector: '.slideout-navigation'
		});

		var selector = '[data-tooltip]';
			var els = document.querySelectorAll(selector);

			for ( var i = 0; i < els.length; i++ ) {
				var dm = new ARIAtip( els[i] );
			}
			
		// paragraphs:
		new duo.Paragraphs();

		// language
		new duo.LanguageSelect();

		// demo - accordions:
		new duo.Accordion({
			containerSelector: '.faq-teaser-list',
			itemSelector:'.node--type-faq-detail.node--view-mode-teaser',
			titleSelector:'.faq-teaser__title',
			contentSelector:'.faq-teaser__text',
			openClass: 'js-item-opened',
			openedIndex: 0,
			enableKeyboardEvents: true,
			onlyAllowOneOpenItem: false
		});

		// SIDEBAR

		// show sidebar (clientzone & FAQ)
		$(document).on('click', '.sidebar__menu-btn', function(event) {
			$('body').addClass('sidebar-is-active');
		});

		// hide sidebar on click outside
		$(document).on('click', '.sidebar-is-active .page-wrapper', function(event) {
			$('body').removeClass('sidebar-is-active');
		});

		// hide sidebar on esc
		$(document).keydown(function(e) {
			if (e.keyCode == 27) {
				if($('body').hasClass('sidebar-is-active')) {
					$('body').removeClass('sidebar-is-active');
				}
			}
		});
	});




/** --------------------------------------------------
    #drupal behavior
    -------------------------------------------------- */

	Drupal.behaviors.default = {
		attach: function (context, settings) {

			// demo - file uploads:
			const fileUploads = new duo.FileUpload({
				fileuploadInputSelector: '.form-type-managed-file .form-file'
			});

			// number spinner:
			const numberSpinner = new duo.NumberSpinner({
				inputSelector: '.form-number'
			});

		}
	};

	Drupal.behaviors.basketCountMobile = {
		attach: function (context, settings) {
			//add basket icon number to mobile view

			if($('#site-header__desktop .cart-block--summary__count').length > 0) {
				const value = $('#site-header__desktop .cart-block--summary__count')[0].innerText;
				$('.mobile-header-cart-total.cart-block--summary__count').text(value);
			}

		}
	};




})(jQuery);
